export default {
    actionButtonStyle: {
        padding: '5px 15px' 
    },
    buttonsContainer: {
        gap: "10px",
    }
}